"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const models_1 = require("@osmosys/models");
exports.featureFlagsDetailData = graphql_tag_1.default `
  fragment featureFlagsDetailData on FeatureFlags {
    ${Object.keys(new models_1.FeatureFlags()).map(ff => {
    return `${ff}\n`;
})}
  }
`;
//# sourceMappingURL=featureFlagsDetailData.js.map